/**
 * @file
 * Simple helpers for the wnc_carnation theme.
 */

(function ($, Drupal) {
  let animateTo = true;
  Drupal.behaviors.wncScrollToPageElement = {
    attach: function attach() {
      function scrollToPageElement() {
        if (window.location.hash.length > 0) {
          // The id of the page element
          let elementToScroll = window.location.hash;
          const $elementByHref = $(`a[href*="${elementToScroll}"]`);
          const $elementById = $(`*[id*=${elementToScroll.replace("#", "")}]`);
          if ($elementById.length > 0) {
            elementToScroll = $elementById;
          } else if (
            $(elementToScroll).length === 0 &&
            $elementByHref.length > 0
          ) {
            elementToScroll = $elementByHref;
          } else {
            elementToScroll = $(elementToScroll);
          }
          if (elementToScroll.length > 0 && animateTo) {
            const $parentElement = elementToScroll
              .closest(".accordion-item")
              .find(".card-header");
            if ($parentElement.length > 0) {
              if (!$parentElement.hasClass("active")) {
                $parentElement.find(".accordion-button").click();
              }
            }
            setTimeout(function () {
              const alertHeight = $("#openy_alerts_app_header").height();
              let resultPosition = 0;
              if ($(window).width() > 1199) {
                const desktopMenu = $("#page-head .desktop-menu").height();
                resultPosition =
                  elementToScroll.offset().top - (desktopMenu + alertHeight);
              } else {
                const mobileMenu = $(
                  ".mobile-navigation .mobile-menu"
                ).height();
                resultPosition =
                  elementToScroll.offset().top - (mobileMenu + alertHeight);
              }
              if (resultPosition > 0 && animateTo) {
                $("html, body").animate(
                  {
                    scrollTop: parseInt(resultPosition, 10),
                  },
                  2000
                );
                animateTo = false;
              }
            }, 500);
          }
        }
      }
      scrollToPageElement();

      $(window).on("hashchange", function () {
        if (!animateTo) {
          animateTo = true;
        }
        scrollToPageElement();
      });
    },
  };
})(jQuery, Drupal);
